// extracted by mini-css-extract-plugin
module.exports = {"Root":"BrowserValidator_Root__1Rq9f","BrowserValidator":"BrowserValidator_BrowserValidator__6OAmL","Text":"BrowserValidator_Text__kYLaf"};